import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import { useDotButton } from "./DotButtons";
import { PrevButton, NextButton, usePrevNextButtons } from "./ArrowButtons";
import useEmblaCarousel from "embla-carousel-react";

type PropType = {
  slides: ITeamMember[];
  options?: EmblaOptionsType;
  hideDescription?: boolean;
};

export interface ITeamMember {
  name: string;
  role: string;
  description: string;
  facebook: string;
  instagram: string;
  twitter: string;
  image: string;
}

const MeetTeamCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex } = useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className="flex flex-1 flex-col justify-center items-center w-full">
      <div className="flex items-center h-full justify-center w-full">
        <div className="w-full mx-auto">
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex gap-16 lg:gap-[4.4rem] max-w-sm">
              {slides.map((data, index) => (
                <div
                  className="min-w-fit max-w-[18rem] border mb-3"
                  key={index}
                >
                  <div className="flex flex-col w-full max-w-[20rem]">
                    <img src={data.image} alt="" className="max-h-56 object-top w-72" />
                    <div className="space-y-1 p-3">
                      <h4 className="font-medium">{data.name}</h4>
                      <h5 className="font-light text-sm">{data.role}</h5>
                      {props.hideDescription ? (
                        ""
                      ) : (
                        <p className="text-[#5F6980] text-xs">
                          {data.description}
                        </p>
                      )}
                      {/* <div className="flex gap-3 pt-1">
                        <Link to={data.facebook}>
                          <img
                            src="/company/facebook.svg"
                            alt=""
                            className="w-8"
                          />
                        </Link>
                        <Link to={data.instagram}>
                          <img
                            src="/company/instagram.svg"
                            alt=""
                            className="w-8"
                          />
                        </Link>
                        <Link to={data.twitter}>
                          <img
                            src="/company/twitter.svg"
                            alt=""
                            className="w-8"
                          />
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-between items-center pt-4">
            <div className="flex items-center gap-1 text-xs">
              {selectedIndex + 1}/{slides.length}
            </div>
            <div className="embla__buttons">
              <PrevButton
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
              />
              <NextButton
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetTeamCarousel;
